import { graphql } from '../gql';

export const validateMutation = graphql(`
  mutation validate(
    $file: Upload!
    $session: String
    $paperFormat: PaperFormat!
    $subject: String!
    $deviceID: String
    $experiments: Map
    $scannerType: String
    $expectedKeyPoints: [FeetKeyPoint!]!
  ) {
    validate(
      req: {
        paperFormat: $paperFormat
        file: $file
        subject: $subject
        deviceID: $deviceID
        experiments: $experiments
        session: $session
        scannerType: $scannerType
        expectedKeyPoints: $expectedKeyPoints
      }
    ) {
      status
      error {
        message
        code
      }
      barefoot
      paperCorners {
        x
        y
      }
      feetKeypoints {
        left {
          heel {
            x
            y
          }
          toe {
            x
            y
          }
          lateralPoint {
            x
            y
          }
          medialPoint {
            x
            y
          }
        }
        right {
          heel {
            x
            y
          }
          toe {
            x
            y
          }
          lateralPoint {
            x
            y
          }
          medialPoint {
            x
            y
          }
        }
      }
    }
  }
`);
